import { Star } from "lucide-react";

// PLACEHOLDER Trustpilot section, user was explicit: do NOT invent fake
// reviews. This uses the exact placeholder copy pattern approved for launch:
// three neutral card slots labelled "Placeholder review" with a "coming
// soon" note pointing to the Trustpilot integration. Swap `IS_LIVE=true`
// and populate REVIEWS array once real reviews land.
const IS_LIVE = false;
const REVIEWS = [];

const PLACEHOLDERS = [
  {
    id: "p1",
    title: "Placeholder review · pending Trustpilot integration",
    body: "Real researcher feedback will appear here once the Trustpilot widget is wired. We do not fabricate reviews.",
    author: "Verified researcher",
  },
  {
    id: "p2",
    title: "Placeholder review · pending Trustpilot integration",
    body: "Real researcher feedback will appear here once the Trustpilot widget is wired. We do not fabricate reviews.",
    author: "Verified researcher",
  },
  {
    id: "p3",
    title: "Placeholder review · pending Trustpilot integration",
    body: "Real researcher feedback will appear here once the Trustpilot widget is wired. We do not fabricate reviews.",
    author: "Verified researcher",
  },
];

export default function TrustpilotReviews() {
  const items = IS_LIVE && REVIEWS.length > 0 ? REVIEWS : PLACEHOLDERS;

  return (
    <section className="border-b border-line" data-testid="trustpilot-reviews">
      <div className="container-pd py-16 lg:py-24">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="label-mono text-brandblue">§ What researchers say</p>
            <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Reviews.
            </h2>
            {!IS_LIVE && (
              <p
                className="mt-3 max-w-lg text-sm text-subtle"
                data-testid="trustpilot-placeholder-note"
              >
                Trustpilot integration pending, placeholder cards below. We&apos;ll
                surface verified reviews from the Trustpilot API once the widget
                is wired and we&apos;ve accumulated our first cohort.
              </p>
            )}
          </div>
          {IS_LIVE && (
            <div className="flex items-center gap-2 text-sm text-subtle">
              <span className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="h-4 w-4 fill-emerald-500 text-emerald-500" strokeWidth={0} />
                ))}
              </span>
              <span>Excellent · Trustpilot</span>
            </div>
          )}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {items.map((r) => (
            <article
              key={r.id}
              className="rounded-lg panel-warm bg-white p-6"
              data-testid={`review-card-${r.id}`}
            >
              <span className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star
                    key={i}
                    className={`h-3.5 w-3.5 ${IS_LIVE ? "fill-emerald-500 text-emerald-500" : "fill-line text-line"}`}
                    strokeWidth={0}
                  />
                ))}
              </span>
              <p className="mt-3 font-heading text-sm font-bold text-ink">{r.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-subtle">{r.body}</p>
              <p className="mt-4 font-mono text-[10px] tracking-[0.14em] text-subtle">
                ● {r.author}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
